import { render, staticRenderFns } from "./abnormalInfo.vue?vue&type=template&id=0edeadd0&scoped=true"
import script from "./abnormalInfo.vue?vue&type=script&lang=js"
export * from "./abnormalInfo.vue?vue&type=script&lang=js"
import style0 from "./abnormalInfo.vue?vue&type=style&index=0&id=0edeadd0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edeadd0",
  null
  
)

export default component.exports